import {
  types,
  IMediaTypeGroups,
  MediaTypeGroupsType,
} from '../types/mediaTypeGroups'

export const initialState: IMediaTypeGroups = {
  isLoading: false,
  list: [],
}

export const mediaTypeGroups = (
  state = initialState,
  action: MediaTypeGroupsType
): IMediaTypeGroups => {
  switch (action.type) {
    case types.GET_MEDIA_TYPE_GROUPS__STARTED:
      return { ...state, isLoading: true }
    case types.GET_MEDIA_TYPE_GROUPS__SUCCESS:
      return { ...state, isLoading: false, list: action.list || [] }
    case types.GET_MEDIA_TYPE_GROUPS__FAILURE:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
